module.exports = __webpack_public_path__ + "img/pic1.1f17c5bf.png";